<script lang="ts">
    let _class = "";
    let _style = "";
    export { _class as class };
    
    export let width: Number | undefined = undefined;
    export let height: Number | undefined = undefined;

    export let type: 'text' | 'circle'  = 'text';
    export let animation: 'pulse' | 'none' = 'pulse';

    function _getClasses(): string {
        const classes: string[] = ['block', 'bg-gray-200', 'h-full'];

        if (animation === 'pulse') classes.push('animate-pulse');
        if (type === 'circle') classes.push('rounded-full');

        return `${classes.join(' ')} ${_class !== undefined ? _class : ''}`;
    }

    function _getStyle(): string {
        const styles: string[] = [];

        if (width) styles.push(`width: ${width}px`);
        if (height) styles.push(`height: ${height}px`);
        
        return styles.join(';');
    }

    _class = _getClasses();
    _style = _getStyle();
</script>

<span class="{_class}" style="{_style}"></span>